import {Row, Col, Form, Input, Space, Button, DatePicker, Select} from 'antd';
import classes from '../Pages.module.css';
import { MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons';

const { Option } = Select;

const ExperienceEdit = (props) => {

    const handleValueChanges = (changedValues, allValues) => {
        console.log(allValues);

        props.setData(data => {

            return({
                ...data,
                experience: allValues.experience
            })
        })
    }

    return(
        <Form layout="vertical" name="filter_form" onValuesChange = {handleValueChanges} autoComplete="off">
            <Form.List name="experience" initialValue = {props.data}>
                {(fields, { add, remove }) => { 
                    
                    return(
                    <>
                        {fields.map(({ key, name, fieldKey, ...restField}) => (
                        <Space key={key} className = {classes['Space']} align="center">
                            <Row gutter = {16}>
                                <p></p>
                                <Col lg = {12} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'COMPANY_NAME']}
                                        fieldKey={[fieldKey, 'COMPANY_NAME']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Company Name</div>}
                                        rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" , float: "left", backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}} 
                                            bordered = {true}
                                            placeholder="Enter Name"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col lg = {12} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'DESIGNATION_CODE']}
                                        fieldKey={[fieldKey, 'DESIGNATION_CODE']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Designation</div>}
                                        rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <Select
                                            bordered = {true}
                                            style={{ width: "100%" , textAlign: "left", float: "left", backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}} 
                                            placeholder="Select"
                                            optionFilterProp="children"
                                        >
                                            {
                                                props.desigOptions.rows.map((option) => {
                                                    return(
                                                        <Option style = {{textTransform: "capitalize", color: "#1777C4"}} key = {option[props.desigOptions.fields[0].name]} value={option[props.desigOptions.fields[0].name]}>{option[props.desigOptions.fields[1].name]}</Option>
                                                    );
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col lg = {8} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'FROM_DATE']}
                                        fieldKey={[fieldKey, 'FROM_DATE']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>From Date</div>}
                                        rules={[{ required: true, message: 'Missing Name' }]}
                                    >   
                                        
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ textAlign: "left", width: "100%" , backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}
                                            bordered = {true}
                                            placeholder="Enter Date" />
                                        
                                    </Form.Item>
                                </Col>
                                <Col lg = {8} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'TO_DATE']}
                                        fieldKey={[fieldKey, 'TO_DATE']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>To Date</div>}
                                        rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ textAlign: "left", width: "100%" , backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}
                                            bordered = {true}
                                            placeholder="Enter Date" />

                                    </Form.Item>
                                </Col>
                                <Col lg = {8} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'GROSS_SALARY']}
                                        fieldKey={[fieldKey, 'GROSS_SALARY']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Gross Salary</div>}
                                        rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" , float: "left", backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}} 
                                            bordered = {true}
                                            placeholder="Enter Salary"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col lg = {21} md = {0}>
                                    
                                </Col>
                                <Col lg = {1} md = {24}>
                                    <MinusCircleOutlined className = {classes['Remove']} onClick={() => { remove(name) }} />
                                </Col>
                                <Col lg = {1} md = {24}>
                                    <PlusCircleOutlined className = {classes['Add']} onClick={() => {add()}} />
                                </Col>
                                <Col lg = {1} md = {24}>
                                    
                                </Col>
                                <Col lg = {24} md = {24}>
                                    <hr></hr>
                                </Col>
                            </Row>                                                     
                        </Space>
                        ))}
                        <Form.Item>
                            <Button type="dashed" className = {classes['DashedButton']}onClick={() => {add()}}>
                                Add Experience
                            </Button>
                        </Form.Item>
                    </>
                )}}
            </Form.List>
        </Form>
    )
}

export default (ExperienceEdit)